import React, { useState } from "react";
import { RCCAlert, RCCButton, RCCChartPieChart, RCCGrid, RCCTooltip } from "react-common-components";
import { Link } from "react-router-dom";
import AppIcons from "src/components/AppIcons";
import DefaultContainer from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultContainer";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import useEffectFetchData from "src/hooks/useEffectFetchData";
import objectToPieChartData from "src/utils/objectToPieChartData";
import HeaderDashboard from "../../../DefaultDashboardComponents/HeaderDashboard";
import { ICardConfigs } from "../../../interface";
import { colorChart, IDashboardProjectsDataPieChart } from "../interface";

const DashboardPieChartProjectsOfProgram: React.FC<ICardConfigs> = ({
	card
}) => {
	const { translate } = useTranslation();
	const [programTitle, setProgramTitle] = useState("");
	const [dataProjects, setDataProjects] = useState<IDashboardProjectsDataPieChart[] | undefined>(undefined);

	const translateNameProjects = (name: string) => {
		switch(name){
		case "inProgress":
			return translate("Em andamento");
		case "notStarted":
			return translate("Não iniciados");
		case "finished":
			return translate("Concluídos");
		case "delayed":
			return translate("Atrasados");
		case "nextToExpire":
			return translate("Próximo de expirar");
		default:
			return "";
		}
	};

	const {loading} = card?.daa002Idorigem ? useEffectFetchData<any> (
		"DashboardProjects/ListProjectsOfProgramForPieChart", 
		{ id: card?.daa002Idorigem },
		({ data }) => {
			let array = objectToPieChartData(data);
			setProgramTitle(array.find((x) => x.name === "programTitle")?.value);
			array = array.filter((x) => x.name !== "programTitle");
			const translateArray = array.filter((x) => x.name !== "count" && x.name !== "percentage" && x.name !== "expectedPercentage").map((x) => ({
				...x,
				name: translateNameProjects(x.name)
			}));
			setDataProjects(translateArray.filter((x) => x.name !== ""));
		}
	): {loading: true};
	
	return (
		<DefaultContainer>
			<HeaderDashboard 
				description={card?.daa002Descricao}
				title={card && card.daa002Titulo.trim().length > 0 ? card.daa002Titulo : translate("Gráfico Projeto por Situação - Programa")}
				hexColor={card?.daa002Cor !== null ? card?.daa002Cor : undefined}
				isLoading={loading}
			>
				<Link to="/projects/panel">
					<RCCTooltip
						text={translate("Painel de Projetos")}
						color="grey"
					>
						<RCCButton
							color="transparent"
						>
							<AppIcons 
								name="projects"
								size={14}
							/>
						</RCCButton>
					</RCCTooltip>
				</Link>
			</HeaderDashboard>

			<RCCGrid container justifyContent="center" style={{height: "250px", position: "relative"}}>
				{dataProjects && dataProjects.length > 0 ? (
					<>
						<Title color="purple" styleInline="position: absolute; top: 0; left: 4px; max-width: 90%;">{programTitle}</Title>
						<RCCChartPieChart
							width={500}
							height={400}
							pie={[{
								data: dataProjects,
								isAnimationActive: true,
								label: true,
								showTotal: true
							}]}
							colorsPallete={colorChart}
						/>
					</>
				): (
					<RCCAlert 
						title={translate("Atenção")}
						description={translate("É necessário selecionar um programa")}
					/>
				)}
			</RCCGrid>
		</DefaultContainer>
	);
};

export default DashboardPieChartProjectsOfProgram;
